<template>
  <div ref="wrapper" class="relative inline-block group">
    <div class="flex flex-col items-start">
      <button
          @click="onTriggerClick"
          class="flex items-center gap-1.5 rounded-lg border border-[#E7E7E7]
               px-2 py-1 transition-colors hover:bg-secondary/10 text-3xl"
      >
        <Icon name="error" class="text-primary" is-filled />
      </button>

      <div
          ref="tooltip"
          class="absolute top-full left-[-1rem] sm:left-0 right-0 mx-auto mt-2 w-[calc(100vw-4rem)] max-w-[475px] sm:w-[475px] py-8 rounded-lg
         bg-white shadow-lg border text-sm text-gray-700 z-50
         transition-all duration-200
         sm:group-hover:opacity-100 sm:group-hover:visible"
          :class="mobileOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
      "
      >
        <strong class="block mb-4 text-xl text-zinc-800 px-8">
          {{ __('Stay safe in your search for employment.') }}
        </strong>
        <ul class="list-disc list-inside space-y-3 text-sm text-zinc-600 px-8">
          <li>{{ __('Ask questions about the job before you go to an interview.') }}</li>
          <li>{{ __('Don’t leave your original passport and ID to employers.') }}</li>
          <li>{{ __('Don’t make any requested payments.') }}</li>
          <li>{{ __('Research the recruiter and the company.') }}</li>
          <li>{{ __('Read the contract before you sign it.') }}</li>
        </ul>
        <p class="block mt-2 text-sm text-zinc-600 pl-8 pr-6">
          {{ __('Read more about how to recognise legitimate employment') }}
          <a href="/privacy-policy" target="_blank" class="text-blue-600 underline">
            {{ __(' here.') }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { Icon } from '@/components/block/icon';
import { __ } from '@/helpers';

const wrapper = ref(null);
const mobileOpen = ref(false);

function onTriggerClick(event) {
  mobileOpen.value = !mobileOpen.value;
  event.stopPropagation();
}

function onDocumentClick(e) {
  if (wrapper.value && !wrapper.value.contains(e.target)) {
    mobileOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', onDocumentClick, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', onDocumentClick, true);
});
</script>


